import React from 'react';

/**
 * Shared navigation component for section navigation
 * Shows back and next buttons with section names
 */
function SectionNavigation({ 
  onNextSection, 
  onPreviousSection, 
  currentSectionIndex, 
  sectionNames 
}) {
  const isFirstSection = currentSectionIndex === 0;
  const isLastSection = currentSectionIndex === sectionNames.length - 1;
  
  return (
    <div className="section-navigation" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
      <div>
        {/* Back button - only show if we're not at the first section */}
        {typeof onPreviousSection === 'function' && !isFirstSection && (
          <div className="nav-button-container">
            <button 
              className="back-section-btn" 
              onClick={onPreviousSection} 
              style={{ 
                padding: '10px 28px', 
                borderRadius: '6px', 
                background: '#fff', 
                color: '#34517a', 
                border: '1px solid #34517a', 
                fontSize: '18px', 
                fontWeight: '600', 
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: '180px'
              }}
            >
              <span>Back</span>
              <span style={{ fontSize: 14, fontWeight: 400, marginTop: 4 }}>
                {sectionNames[currentSectionIndex - 1]}
              </span>
            </button>
          </div>
        )}
      </div>

      <div>
        {/* Next Section button - don't show on last section */}
        {typeof onNextSection === 'function' && !isLastSection && (
          <div className="nav-button-container">
            <button 
              className="next-section-btn" 
              onClick={onNextSection} 
              style={{ 
                padding: '10px 28px', 
                borderRadius: '6px', 
                background: '#34517a', 
                color: 'white', 
                border: 'none', 
                fontSize: '18px', 
                fontWeight: '600', 
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: '180px'
              }}
            >
              <span>Next Section</span>
              <span style={{ fontSize: 14, fontWeight: 400, marginTop: 4 }}>
                {sectionNames[currentSectionIndex + 1]}
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SectionNavigation;
